const assetsEn = {
    asset: require('../../lang/en/assets/Asset').default,
    assetIssue: require('../../lang/en/assets/AssetIssue').default,
    inventory: require('../../lang/en/assets/Inventory').default,
}

export default assetsEn;

